module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_01-d06d3641e12ad7ce341e2fc8819e5543.png";